export default function ContainerBenefits() {
  const benefits = [
    {
      title: '快速部署',
      description: '使用 Docker 镜像，一条命令即可启动服务，无需复杂的环境配置',
      icon: 'ri-rocket-line',
      stats: '5分钟部署'
    },
    {
      title: '成本优化',
      description: '按需使用，弹性扩展，有效降低基础设施成本和运维开销',
      icon: 'ri-money-dollar-circle-line',
      stats: '节省60%成本'
    },
    {
      title: '开发友好',
      description: '完善的 API 文档和示例代码，快速集成到现有系统中',
      icon: 'ri-code-s-slash-line',
      stats: '30分钟集成'
    },
    {
      title: '运维简单',
      description: '自动化监控和日志管理，降低运维复杂度，提升服务稳定性',
      icon: 'ri-settings-3-line',
      stats: '99.9%可用性'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-teal-600 via-cyan-600 to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold mb-4">
            为什么选择 PDF REST Container
          </h2>
          <p className="text-xl text-white/90 max-w-3xl mx-auto">
            现代化的架构设计，为企业带来显著的业务价值
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/20 transition-all duration-300"
            >
              <div className="flex items-start space-x-6">
                <div className="w-16 h-16 flex items-center justify-center rounded-xl bg-white/20 flex-shrink-0">
                  <i className={`${benefit.icon} text-3xl text-white`}></i>
                </div>
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-3">
                    <h3 className="text-2xl font-bold">{benefit.title}</h3>
                    <span className="text-cyan-200 font-semibold text-sm">{benefit.stats}</span>
                  </div>
                  <p className="text-white/90 leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Use Cases */}
        <div className="mt-20">
          <h3 className="text-3xl font-bold text-center mb-12">适用场景</h3>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
              <i className="ri-building-line text-4xl mb-4 text-cyan-200"></i>
              <h4 className="text-xl font-bold mb-2">企业应用</h4>
              <p className="text-white/80 text-sm">文档管理系统、OA 办公平台</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
              <i className="ri-shopping-cart-line text-4xl mb-4 text-cyan-200"></i>
              <h4 className="text-xl font-bold mb-2">电商平台</h4>
              <p className="text-white/80 text-sm">订单处理、发票生成、合同管理</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
              <i className="ri-government-line text-4xl mb-4 text-cyan-200"></i>
              <h4 className="text-xl font-bold mb-2">政务系统</h4>
              <p className="text-white/80 text-sm">公文处理、档案管理、证照生成</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
